import * as React from 'react';
import { DropDown, Input, SystemPanel, SystemPopup } from '../../../library';
import ArchiveAuditGrid from './ArchiveAuditGrid';

interface IAuditFormProps {
    visible: boolean, table: string, schema: string,
    secondaryTable: string, secondarySchema: string,
    onClose(): void, primaryKeyEncrypted: string, secondaryKeyEncrypted: string
}
interface IAuditFormState {
    ContextId: string,
    Schema: string,
    Table: string
}
//const schema = "Reference";
//const table = "CommunicationTemplate";
//const primaryKeyEncrypted = "";
export default class ArchiveForm extends React.Component<IAuditFormProps, IAuditFormState> {
    constructor(props: any) {
        super(props);
        this.state = { ContextId: '',Schema:'',Table:'' }
       
    }
    //onRowClick = (data: any) => {
    //    if (data && data.ContextId) {
    //        this.setState({ ContextId: data.ContextId });
    //    }
    //}
    //handleChange = (e: any) => {
    //    if(e.value)
    //        this.setState({ Schema: e.value.Key });
    //    this.setState({ Table: '' });
    //}
    //handleTableChange = (e: any) => {
    //    if (e.value)
    //    this.setState({ Table: e.value.Key });
    //}
    render() {
        return (<>
            <SystemPopup visible={this.props.visible} onClose={this.props.onClose} popupTitle="Archive Data" popupWidth="1000px">
                < ArchiveAuditGrid Schema={this.props.schema}
                    Table={this.props.table}
                    primaryKey={this.props.primaryKeyEncrypted} />
            </SystemPopup>
            </>)
      
   }
}



